import React from 'react';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';

import Button from 'components/Button';

const Container = styled.div`
  li {
    display: flex;
    flex-direction: row;
    max-width: 229px;
    height: 45px;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    color: #1c2b38;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-transform: uppercase;
    min-width: 260px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin: 2px 0;
      max-width: 100%;
    }

    .action-menu-item {
      background-color: #ebecee;

      @media (max-width: ${(props) =>
          props.theme.devices.isTablet ? '0px' : '845px'}) {
        border-radius: 24px;
      }
    }

    .action-menu-item.favorite {
      background-color: ${(props) => props.theme.colors['terra-cotta']};
    }

    .icon {
      margin-right: 10px;
      font-size: 1.3em;
    }
  }
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

function renderListButton({
  type = undefined,
  download = undefined,
  url = undefined,
  label,
  icon,
  onClick = undefined
}) {
  return (
    <li>
      <Button
        font-weight={400}
        type={type}
        onClick={onClick}
        downloadLink={download}
        url={url}
        width="100%"
        label={label}
        icon={icon}
        iconLeft
        textColor="#1c2b38"
        color="#f7f7f7"
        className="action-menu-item"
        fontFamily="Oswald"
        style={{ padding: '0 15px' }}
      />
    </li>
  );
}

function renderCommonButton(onClick, label, icon) {
  return renderListButton({ onClick, label, icon });
}

function renderLinkButton(url, label, icon, download = undefined) {
  return renderListButton({ type: 'link', url, label, icon, download });
}

function ActionMenu({
  onClickShare,
  onClickFavorite,
  onClickRead,
  onClickTag,
  onClickTranslate,
  originalContent,
  onClickDlPdf,
  isFavorite
}) {
  return (
    <Container>
      <List>
        <li>
          {isFavorite ? (
            <Button
              onClick={onClickFavorite}
              label={I18n.t('media.actionMenu.favorited')}
              className={'action-menu-item ' + (isFavorite ? ' favorite' : '')}
              icon="starsCheck"
              iconColor="white"
              fontFamily="Oswald"
              iconLeft
              width={'100%'}
            />
          ) : (
            <Button
              className="action-menu-item titleFavorited"
              onClick={onClickFavorite}
              label={I18n.t('media.actionMenu.toFavorite')}
              icon="starsCheck"
              iconColor="#1c2b38"
              textColor="#1c2b38"
              color={'#f7f7f7'}
              fontFamily="Oswald"
              iconLeft
              width={'100%'}
            />
          )}
        </li>
        {onClickRead &&
          renderCommonButton(
            onClickRead,
            I18n.t('media.actionMenu.read'),
            'eye2'
          )}
        {onClickTranslate &&
          renderCommonButton(
            onClickTranslate,
            I18n.t('media.actionMenu.translate'),
            'translate'
          )}
        {onClickTag &&
          renderCommonButton(onClickTag, I18n.t('media.actionMenu.tag'), 'tag')}
        {/* {onClickTag && renderCommonButton(undefined, 'Commenter', 'comments')} */}
        {originalContent &&
          renderLinkButton(
            originalContent,
            I18n.t('media.actionMenu.openOriginal'),
            'openLink'
          )}
        {onClickDlPdf &&
          renderCommonButton(
            onClickDlPdf,
            I18n.t('media.actionMenu.downloadPdf'),
            'download'
          )}
        {onClickShare &&
          renderCommonButton(
            onClickShare,
            I18n.t('media.actionMenu.share'),
            'share'
          )}
      </List>
    </Container>
  );
}

export default ActionMenu;
